import { useState, useLayoutEffect, useRef, memo } from "react"
import styled from "@emotion/styled"
import { useFrameAnimation } from "./FrameAnimation"
import { mvSubscribe } from "./utils"
import { useConsole } from "contexts/Console"
import Image from "components/media/ImageCLD"
import { useEnv } from "contexts/Env"

const Main = styled.section`
  grid-row: 1/-1;
  grid-column: 1/-1;
  position: relative;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;

  & > div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 0;
    animation-fill-mode: both;
    animation-name: wvwbgfadeout;
    animation-duration: 0ms;
    animation-timing-function: cubic-bezier(0.61, 1, 0.88, 1);
    animation-delay: 400ms;
    &.wv_reveal {
      animation-name: wvwbgfadein;
      animation-duration: 400ms;
      animation-delay: 0ms;
    }

    & picture {
      display: contents;
    }
    & img {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: cover;
      //        display: none;
    }
  }

  &.wv_straight {
    > div {
      visibility: hidden;
      animation-delay: 0ms;
      animation: none;
      &.wv_reveal {
        visibility: visible;
      }
    }
  }

  @keyframes wvwbgfadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes wvwbgfadeout {
    0% {
      opacity: initial;
    }
    100% {
      opacity: 0;
    }
  }
`

const BackgroundWatch = styled.div`
//  filter: brightness(104%);
  //  background: blue;
`

const BackgroundZoom = styled.div`
//  filter: brightness(104%);
  //  background: yellow;
`

const BackgroundSide = styled.div`
//  background: white;
`

const BackgroundBracelet = styled.div`
  //  background: pink;
`

const BackgroundDial = styled.div`
//  filter: brightness(104%);
  //  background: green;
`

export const CfgBackgroundWatch = memo(({ active }) => {
  const { catalogYear, catalogueNewPath } = useEnv()
  const image = {
    alt: "",
    loading: "eager",
    sizes: "100vw",
    sources: [
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-cover-background`,
      },
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-cover-background-portrait`,
        metadata: {
          v7_type: ["portrait"],
        },
      },
    ],
  }

  return (
    <BackgroundWatch className={active ? " wv_reveal" : ""}>
      <Image {...image} />
    </BackgroundWatch>
  )
})

const CfgBackgroundZoom = memo(({ active }) => {
  const { catalogYear, catalogueNewPath } = useEnv()
  const image = {
    alt: "",
    loading: "eager",
    sizes: "100vw",
    sources: [
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-watch-view-background`,
      },
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-watch-view-background-portrait`,
        metadata: {
          v7_type: ["portrait"],
        },
      },
    ],
  }

  return (
    <BackgroundZoom className={active ? " wv_reveal" : ""}>
      <Image {...image} />
    </BackgroundZoom>
  )
})

export const CfgBackgroundSide = memo(({ active }) => {
  const { catalogYear, catalogueNewPath } = useEnv()
  const image = {
    alt: "",
    loading: "eager",
    sizes: "100vw",
    sources: [
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-case-view-background`,
      },
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-case-view-background-portrait`,
        metadata: {
          v7_type: ["portrait"],
        },
      },
    ],
  }

  return (
    <BackgroundSide className={active ? " wv_reveal" : ""}>
      <Image {...image} />
    </BackgroundSide>
  )
})

const CfgBackgroundBracelet = memo(({ active }) => {
  const { catalogYear, catalogueNewPath } = useEnv()
  const image = {
    alt: "",
    loading: "eager",
    sizes: "100vw",
    sources: [
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-bracelet-view-background`,
      },
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-bracelet-view-background-portrait`,
        metadata: {
          v7_type: ["portrait"],
        },
      },
    ],
  }

  return (
    <BackgroundBracelet className={active ? " wv_reveal" : ""}>
      <Image {...image} />
    </BackgroundBracelet>
  )
})

const CfgBackgroundDial = memo(({ active }) => {
  const { catalogYear, catalogueNewPath } = useEnv()
  const image = {
    alt: "",
    loading: "eager",
    sizes: "100vw",
    sources: [
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-cover-background`,
      },
      {
        public_id: `${catalogueNewPath}/${catalogYear}/bg/configurator/configurator-cover-background-portrait`,
        metadata: {
          v7_type: ["portrait"],
        },
      },
    ],
  }

  return (
    <BackgroundDial className={active ? " wv_reveal" : ""}>
      <Image {...image} />
    </BackgroundDial>
  )
})

function buildZIndexes(arr) {
  let k = 1
  return arr.reduce((a, item) => {
    a[item] = k++
    return a
  }, Object.create(null))
}

function firstPos(arr, item) {
  const index = arr.indexOf(item)
  if (index < 0) return
  arr.splice(index, 1)
  arr.unshift(item)
}

function animate(list, selected, zIndexes) {
  list.forEach((el, i) => {
    el.style.zIndex = zIndexes[i]
    //    console.log("animate", i, selected, i === selected)
    el.classList[i === selected ? "add" : "remove"]("wv_reveal")
  })
}

function useHighlight(Ctx, items, rf) {
  const console = useConsole()
  const { bkg, canvasview, swapping, lastStep } = useFrameAnimation(Ctx)
  const listRef = useRef(null)
  const colRef = useRef(null)
  const rfpassed = useRef(false)

  function update() {
    //    console.log("update", model)
    //    console.log("fetching", fetching.get())
    let view = canvasview.get()
    if (!view) return
    view = swapping.get() && lastStep() ? "dial" : view
    if (rfpassed.current) rf.current.classList.remove("wv_straight")
    const current = listRef.current
    if (!current) return
    if (bkg.get() === view) return
    bkg.set(view)
    //    const el = items.find(item => item === modelview)
    const index = items.indexOf(view)
    firstPos(current, index)
    const zIndexes = buildZIndexes(current.slice().reverse())
    animate(colRef.current, index, zIndexes)
    rfpassed.current = true
  }

  useLayoutEffect(() => {
    if (!items) return
    listRef.current = items.map((v, i) => i)
    colRef.current = [...rf.current.querySelectorAll("div")]
  }, [items])

  //  useLayoutEffect(() => mvSubscribe(model, update, false), [])
  useLayoutEffect(() => mvSubscribe(canvasview, update), [])
  useLayoutEffect(() => mvSubscribe(swapping, update, false), [])
}

const BG_VIEWS_LABELS = ["watch", "zoom", "side", "bracelet", "dial"]

export const CfgBackgrounds = memo(({ Ctx }) => {
  const console = useConsole()
  const { bkg } = useFrameAnimation(Ctx)
  const rfmain = useRef()
  const all = BG_VIEWS_LABELS.map(v => v)

  const [items] = useState(all)

  useHighlight(Ctx, items, rfmain)

  return (
    <Main ref={rfmain} className='wv_straight'>
      {items?.map(v => {
        switch (v) {
          case "watch":
            return <CfgBackgroundWatch uid={v} key={v} active={bkg.get() === v} />
          case "zoom":
            return <CfgBackgroundZoom uid={v} key={v} active={bkg.get() === v} />
          case "side":
            return <CfgBackgroundSide uid={v} key={v} active={bkg.get() === v} />
          case "bracelet":
            return <CfgBackgroundBracelet uid={v} key={v} active={bkg.get() === v} />
          case "dial":
            return <CfgBackgroundDial uid={v} key={v} active={bkg.get() === v} />
          default:
            return null
        }
      })}
    </Main>
  )
})
